import { SHOPS, ShopId } from '~/constants/shop';

const DEFAULT_VALUES = {
  sellerName: '메루카리 개인 판매자',
  shopNameKor: '',
  shortDesc: '',
} as const;

export const getShopInfo = (_shopId?: ShopId) => (_shopId ? SHOPS[_shopId] || DEFAULT_VALUES : DEFAULT_VALUES);
export const getPaymentNotices = (_shopId?: ShopId) => {
  const sellerName = getShopInfo(_shopId).sellerName;
  return [
    `본 상품은 ${sellerName} 상품으로, 번개장터의 파트너사가 상품 구매와 배송을 대행해요.`,
    '파트너사가 상품 구매 절차를 진행한 이후에는 취소/환불이 제한될 수 있어요. (단, 판매자가 동의하면 취소/환불 가능해요.)',
    '통관 진행을 위해 수령인의 개인통관고유부호 입력이 필요해요.',
  ];
};
